import React, {
  ReactElement,
  useMemo,
} from 'react';
import {
  Collapse,
  IconButton,
  Stack,
} from '@mui/material';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {MoreOptions} from '../assets/MoreOptions';
import {accommodationReservation} from '../../../schema/accommodationReservation';
import {Entity} from '../../../types/entities/Entity';
import Tooltip from '@mui/material/Tooltip';
import {CheckRounded, CloseRounded} from "@mui/icons-material";
import Avatar from "@mui/material/Avatar";
import * as Icons from "@mui/icons-material";

export const CollapseRow = <T extends Entity>({
                                                row,
                                                clickOnEdit,
                                                clickOnDelete,
                                                clickOnRestore,
                                                fullWidth,
                                              }: {
  row: any;
  clickOnEdit: (item: any) => void;
  clickOnDelete: (item: any) => void;
  clickOnRestore: (item: any) => void;
  fullWidth: boolean;
}): ReactElement => {
  const [open, setOpen] = React.useState(false);
  const schema = React.useMemo(() => {
    return accommodationReservation();
  }, []);

  const addresses = useMemo(() => {
    const addressesArray = row?.accommodation?.addresses
      ? [...row.accommodation.addresses]
      : [];
    return addressesArray.map((address) => {
      return `${address?.name}`;
    });
  }, []);

  const IconComponent = Icons[row.reservation_status?.icon?.name as keyof typeof Icons];

  return (
    <>
      <React.Fragment>
        <TableRow sx={{
          '& > *': {borderBottom: 'unset'},
          opacity: row?.reservation_status?.id===4 ? 0.5 : 1,
          textDecoration: row?.reservation_type_id === 4? 'line-through' : ''
        }}>
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
            </IconButton>
          </TableCell>
          <TableCell
            component="th"
            scope="row"
            sx={{
              background: (row.booked_by?.color && !row?.deleted_at)
                ? row.booked_by.color?.color
                : 'transparent',
              cursor: 'pointer',
              color: row.booked_by?.color?.id===21 ? '#f9f9f9':'inherit'
            }}
            onClick={()=>{
              clickOnEdit(row);
            }}
          >
            {row.accommodation?.name}
          </TableCell>
          {fullWidth && (
            <>
              <TableCell align="left">{row.reservation_type?.name}</TableCell>
              <TableCell align="center">
                {row.reservation_status?.icon ? (
                  <Tooltip title={row.reservation_status?.name ? row.reservation_status?.name : ''}>
                    <div>

                      <Avatar
                        sx={{
                          background: `${
                            row.reservation_status?.color?.color
                              ? row.reservation_status?.color?.color
                              : '#FFFFFF00'
                          }`,
                          width: 20,
                          height: 20,
                          '& .MuiSvgIcon-root':{
                            fontSize: '16px'
                          }
                        }}
                      >
                        {row.reservation_status?.icon && (
                          <>{IconComponent ? <IconComponent /> : null}</>
                        )}
                      </Avatar>
                    </div>
                  </Tooltip>

                ) : (
                  <>{row.reservation_status?.name}</>
                )}
              </TableCell>
              <TableCell align="left">{addresses.join(',')}</TableCell>
            </>
          )}
          <TableCell align="center">{`${row.arrival} - ${row.departure}`}</TableCell>
          <TableCell align="right">{row.size}</TableCell>
          <TableCell align="right">
            {row?.deleted_at ? (
              <MoreOptions
                disabledEdit={true}
                clickOnEdit={() => {
                  clickOnEdit(row);
                }}
                clickOnDelete={() => {
                  clickOnDelete(row);
                }}
                clickOnRestore={() => {
                  clickOnRestore(row);
                }}
              />
            ) : (
              <MoreOptions
                clickOnEdit={() => {
                  clickOnEdit(row);
                }}
                clickOnDelete={() => {
                  clickOnDelete(row);
                }}
              />
            )}


          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Stack direction={'column'} sx={{margin: 1}}>
                {(Object.keys(schema.columns) as Array<keyof T>).map(
                  (column, index: number) => {
                    const {name, fieldType} = schema.columns[column as keyof {}];

                    let value = row[column]?.name
                      ? row[column]?.name
                      : (row[column]?.url ? row[column]?.url : (row[column]?.id ? row[column]?.id : row[column]));

                    if (fieldType === 'boolean') {
                      value = !value ? <CloseRounded color={'error'}/> : <CheckRounded color={'success'}/>;
                    }
                    if (fieldType === 'file') {

                      const items = row[column].map((fileItem:any)=> {

                        const link = fileItem?.link;
                        return `<a target={'_blank'} href=${link}>${fileItem?.name}</a>`;
                      });

                      value = items.join("<br>");
                    }

                    return (
                      <>
                        <Stack
                          direction={'row'}
                          sx={{
                            borderBottom: '1px solid #ededed',
                          }}
                        >
                          <Stack
                            sx={{
                              width: '200px',
                              borderRight: '1px solid #ededed',
                              p: '5px',
                            }}
                          >
                            {name}
                          </Stack>
                          <Stack
                            sx={{
                              p: '5px',
                            }}
                          >
                            {fieldType === 'file' ? (
                              <div dangerouslySetInnerHTML={{__html: value}}>

                              </div>
                            ) : (
                              <>
                                {value}
                              </>
                            )}


                          </Stack>
                        </Stack>
                      </>
                    );
                  }
                )}
              </Stack>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    </>
  );
};
